// extracted by mini-css-extract-plugin
export default {"SwitchComponentContainer":"SwitchComponent_SwitchComponentContainer__eBDEk","SwitchSection":"SwitchComponent_SwitchSection__FpGp9","Text2":"SwitchComponent_Text2__enHNg"};